import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { chevronDown } from "@tql/ui-components-react/untitled/icons";
import { useAtomValue } from "jotai";

import { useIsMobile } from "~/shared/hooks/use-is-mobile.ts";
import { selectedCustomerAtom } from "~/shared/state/user-profile-state.ts";

import styles from "./active-profile-display.module.css";

const MOBILE_BREAKPOINT = 480;
const CUSTOMER_NAME_TRUNCATE_LENGTH = 18;

type ActiveProfileDisplayProps = {
	readonly onToggle: () => void;
};

export function ActiveProfileDisplay({ onToggle }: ActiveProfileDisplayProps) {
	const selectedCustomer = useAtomValue(selectedCustomerAtom);
	const isMobile = useIsMobile(MOBILE_BREAKPOINT);

	const customerDisplay = selectedCustomer ? `${selectedCustomer.name}` : "";
	const displayText =
		isMobile && customerDisplay.length >= CUSTOMER_NAME_TRUNCATE_LENGTH
			? `${customerDisplay.slice(0, CUSTOMER_NAME_TRUNCATE_LENGTH)}…`
			: customerDisplay;

	return (
		<div data-testid={"active-profile-display"}>
			{selectedCustomer ? (
				<div className={styles.profileContainer}>
					<h4 className={styles.profileLabel}>Active Profile:</h4>{" "}
					<h5 className={styles.customerName}>{displayText}</h5>
					<span className={styles.profileSeparator}>|</span>
					<button
						className={styles.swapProfileButton}
						data-testid={"swap-profile-button"}
						onClick={onToggle}
						type={"button"}
					>
						Swap Active Profile
						<SvgIcon icon={chevronDown} size={"small"} />
					</button>
				</div>
			) : (
				""
			)}
		</div>
	);
}
